<script>
import { mapGetters } from "vuex";

import { checkApply, checkSkipCheck } from "@/api/vehicle";
import { showPhoneAlarm } from "@/global/function.js";

export default {
  props: {
    visible: Boolean,
    type: String,
    defaultValue: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    const form = {
      data: {},
      rules: {
        status: [
          { required: true, message: "请选择审核状态", trigger: "onChange" },
        ],
      },
    };

    return {
      form,
    };
  },
  computed: {
    ...mapGetters({
      userid: "user/userid",
      name: "user/name",
    }),
    showPop: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit("update:visible", value);
      },
    },
    title() {
      return "审核" + (this.type === "check" ? "加油申请" : "跳过验证");
    },
  },
  methods: {
    async onSubmit() {
      const payload = {
        id: this.defaultValue.id,
        status: this.form.data.status,
        remark: this.form.data.remark,
        checkBy: this.userid,
        checkName: this.name,
        skipVerifyCheckName: this.name,
      };

      let response = undefined;
      if (this.type === "check") {
        response = await checkApply(payload).catch(() => false);
      } else {
        response = await checkSkipCheck(payload).catch(() => false);
      }

      if (response) {
        const { data } = response;
        if (
          showPhoneAlarm(true, "toast", null, 2000, data.code, "审核申请", data.message)
        ) {
          this.$emit("success");
        }
      }
    },
    handleClose() {
      this.$refs.form.resetValidation();
      this.form.data = {};
      this.$emit("closed");
    },
  },
};
</script>

<template>
  <van-popup
    v-model="showPop"
    round
    position="bottom"
    closeable
    close-icon-position="top-right"
    @closed="handleClose"
  >
    <div class="edit-pop">
      <div class="edit-pop-title">
        <div>{{ title }}</div>
        <div class="edit-pop-subtitle">
          加油申请
        </div>
      </div>
      <van-form
        ref="form"
        @submit="onSubmit"
      >
        <van-field
          name="status"
          label="审核状态"
        >
          <template #input>
            <van-radio-group
              v-model="form.data.status"
              direction="horizontal"
            >
              <van-radio name="1">
                通过
              </van-radio>
              <van-radio name="-1">
                拒绝
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-model="form.data.remark"
          clear-trigger="always"
          name="remark"
          label="审核备注"
          placeholder="可选"
        />
        <div style="height: 100px" />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="primary"
            native-type="submit"
          >
            提交
          </van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
</template>

<style lang="scss" scoped>
.edit-pop {
  .edit-pop-title {
    font-size: 18px;
    font-weight: bold;
    padding: 16px 24px;
  }
  .edit-pop-subtitle {
    font-size: 14px;
    color: gray;
    font-weight: lighter;
  }
}
</style>